export default __webpack_public_path__ + "static/bg-account-8394679bcecd87065bcb796e2de44910.jpg";